// Toasts (notificações efêmeras). Store global; o container é montado uma vez
// no shell e se inscreve aqui.
import { atom } from 'nanostores';

export interface Toast {
  id: number;
  message: string;
  kind: 'info' | 'ok' | 'bad';
}

export const $toasts = atom<Toast[]>([]);
let seq = 0;

export function toast(message: string, kind: Toast['kind'] = 'info', ms = 4000): void {
  const id = ++seq;
  $toasts.set([...$toasts.get(), { id, message, kind }]);
  setTimeout(() => dismissToast(id), ms);
}

export function dismissToast(id: number): void {
  $toasts.set($toasts.get().filter((t) => t.id !== id));
}

export const toastOk = (m: string) => toast(m, 'ok');
// Erros ficam o dobro do tempo (dá tempo de ler).
export const toastBad = (m: string) => toast(m, 'bad', 8000);
